<template>
  <v-row class="game-cards-container">
    <v-col cols="12" md="12" lg="12" class="mx-auto mb-4">
      <v-alert
        dense
        type="info"
        text
        border="left"
        class="mb-4 text-body-2"
        elevation="2"
      >
        <strong>راهنما:</strong> با وارد کردن عدد در کادر زیر، تعیین می‌کنید که
        امتیازات چند بار بازی کردن با یکدیگر جمع بسته شوند. در صورت خالی گذاشتن
        این فیلد، فقط امتیاز یک بازی در نظر گرفته می‌شود.
      </v-alert>
      <v-text-field
        class="md-6 lg-3"
        v-model.number="playCount"
        label="حداکثر تعداد بازی برای جمع امتیاز"
        placeholder="مثلاً: 2"
        outlined
        dense
        type="number"
        min="1"
        hide-details="auto"
      ></v-text-field>
    </v-col>
    <v-col
      v-for="(game, i) in games"
      :key="game.name"
      cols="12"
      sm="6"
      md="6"
      lg="4"
    >
      <v-card
        class="game-card mx-auto mb-6 position-realtive"
        elevation="3"
        rounded="xl"
        :class="{
          'game-card--selected': isSelected(game),
          'game-card--hover': hoveredIndex === i,
        }"
        @click="selectGame(i, game)"
        @mouseenter="hoveredIndex = i"
        @mouseleave="hoveredIndex = null"
      >
        <div class="cover-wrapper">
          <img :src="game.cover" class="cover-image" alt="Game cover" />
          <div v-if="isSelected(game)" class="selected-overlay">
            <v-icon large color="white">mdi-check-circle</v-icon>
          </div>
        </div>

        <v-card-title
          class="pt-5 pb-3 text-h6 font-weight-bold gametitle"
          :class="game.type === 'public' ? 'mb-13 pt-5' : ''"
        >
          {{ game.title }}
          <small class="pb-5 pt-5 text-body-2"> {{ game.subtitle }} </small>
        </v-card-title>

        <v-card-actions class="justify-center pb-6 flex-wrap">
          <v-btn
            :class="isSelected(game) ? 'btn-upload' : 'btn-get-code'"
            class="game-card-btn px-8 rounded-lg"
            @click.stop="openGameModal(game, i)"
          >
            {{ isSelected(game) ? "انتخاب شده" : "تست بازی" }}
          </v-btn>
          <v-btn
            v-if="game.type === 'public'"
            class="game-card-btn px-6 mx-2 mb-2 rounded-lg btn-get-code"
            @click.stop="$emit('edit')"
          >
            تنظیمات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Bus } from "@/main";

export default {
  name: "GameSelector",
  props: {
    value: {
      type: [Object, null],
      default: null,
    },
  },

  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      // متغیر کمکی برای نگهداری مقداری که تایپ می‌شود
      localCount: null,
      selectedIndex: null,
      hoveredIndex: null,
      games: [
        {
          type: "private",
          cover: require("@/assets/images/game/background2_22.webp"),
          name: "EnzymeSquad",
          title: "لیگ آنزیم‌های قهرمان سپید+",
          subtitle: "با قدرت ۵ آنزیم سپید+، لکه‌ها را نابود کنید!",
          background: require("@/assets/images/game/background1.webp"),
          component: "EnzymeSquad",
          src: require("@/assets/images/game/280x280.webp"),
        },
        {
          component: "CoolWashRun",
          type: "private",
          cover: require("@/assets/images/game/background_sepid.webp"),
          name: "CoolWashRun",
          title: "فرار در ۳۰ درجه",
          subtitle: "لباست رو از آب داغ نجات بده!",
          background: require("@/assets/images/game/background12.webp"),
          src: require("@/assets/images/game/sepid5.webp"),
        },
        {
          component: "SortItOut",
          type: "private",
          cover: require("@/assets/images/game/background_qr.webp"),
          name: "SortItOut",
          title: "کارآگاه تفکیک لباس",
          subtitle: "لباس‌ها رو سریع به سبد درست بنداز!",
          background: require("@/assets/images/game/background11.webp"),
          src: require("@/assets/images/game/logo (2).webp"),
        },
        {
          type: "public",
          cover: require("@/assets/images/game/cover_220.webp"),
          name: "Game",
          title: "جمع آوری کیوارها",
          background: require("@/assets/images/game/background_qr2.webp"),
          src: require("@/assets/images/game/logo (2).webp"),
        },
        {
          type: "public",
          cover: require("@/assets/images/game/cover_meg_220.webp"),
          name: "MeepMeepProRunner",
          title: "میگ میگ در سرزمین کیوار",
          background: require("@/assets/images/game/mountains3.webp"),
          src: require("@/assets/images/game/logo (2).webp"),
        },
      ],
    };
  },
  computed: {
    selectedGame() {
      return this.value;
    },

    playCount: {
      get() {
        if (this.localCount !== null) {
          return this.localCount;
        }
        return this.value && this.value.count_paly
          ? this.value.count_paly
          : null;
      },
      set(newVal) {
        this.localCount = newVal === "" ? null : newVal;

        if (this.value) {
          const validCount =
            this.localCount && this.localCount > 0 ? this.localCount : 1;
          this.$emit("input", {
            ...this.value,
            count_paly: validCount,
          });
        }
      },
    },
  },

  methods: {
    isSelected(game) {
      if (!this.selectedGame) return false;
      if (this.selectedGame.type === "public" && this.selectedGame.config) {
        return this.selectedGame.config.type === game.name;
      }
      return this.selectedGame.name === game.name;
    },

    selectGame(index, game) {
      const finalCount =
        this.localCount && this.localCount > 0 ? this.localCount : 1;

      if (
        game.type === "public" &&
        this.value &&
        this.value.config &&
        this.value.config.type === game.name
      ) {
        this.$emit("input", {
          type: "public",
          name: game.name,
          config: this.value.config,
          count_paly: finalCount,
        });
      } else {
        this.$emit("input", { ...game, count_paly: finalCount });
      }
    },

    openGameModal(game, index) {
      this.selectGame(index, game);
      Bus.$emit("open-game-modal", { game, index });
    },
  },
};
</script>

<style scoped>
.game-cards-container {
  padding: 16px;
}

.game-card {
  width: 100%;
  max-width: 360px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  border-radius: 20px !important;
  position: relative;
}

.game-card:hover,
.game-card--hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.22) !important;
}

.game-card--selected {
  border: 3px solid var(--v-primary-base);
  box-shadow: 0 16px 36px -12px var(--v-primary-base) !important;
  transform: translateY(-6px);
}

.cover-wrapper {
  position: relative;
  overflow: hidden;
}

.cover-image {
  transition: transform 0.45s ease;
  width: 100% !important;
  height: 220px !important;
  object-fit: contain;
  display: block;
  border-radius: 16px !important;
}

.game-card:hover .cover-image {
  transform: scale(1.07);
}

.selected-overlay {
  position: absolute;
  inset: 0;
  background: rgba(25, 118, 210, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.game-card-btn {
  min-width: 130px !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

@media (max-width: 600px) {
  .game-card {
    max-width: 100%;
  }
}
.gametitle {
  white-space: nowrap !important;
  position: absolute;
  bottom: 15% !important;
  left: auto !important;
  right: auto !important;
  color: white !important;
  text-shadow: 1px 3px rgba(0, 0, 0, 0.897) !important;
  background-color: rgba(30, 41, 77, 0.3);
  width: 100% !important;
  backdrop-filter: blur(10) !important;
  padding-bottom: 8px;
  padding-top: 8px;
  word-break: keep-all !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  white-space: normal !important;
}
</style>
